<template>
  <div class="ma-4">
    <v-card v-if="!dataLoaded">
      <v-card-title>Academic Program/Advisor Change Form (Loading...)</v-card-title>
    </v-card>
    <change-status v-else-if="'program' in submission && submission.program.length > 0 && status !== 'Returned'" :submission="submission" :term-label="termLabel" @update="(data) => submission = data"></change-status>
    <template v-else>
      <v-toolbar>
        <v-toolbar-title>Academic Program/Advisor Change: {{ termLabel }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="mb-2">
        <v-card-text>
          <p>This form shows your current major(s), with advisor and any concentrations, and any minors. You can use the buttons on the bottom of each card to change something with the selected block.</p>
          <p>Please note that while you can request to change your advisor, you might be assigned a different advisor based on if the requested advisor is going on sabbatical, or to keep the department's advising duties balanced between professors, or based on a system developed by the department of the selected major.</p>
        </v-card-text>
      </v-card>
      <v-row class="my-2">
        <!-- <v-col v-for="({ major, advisors, concentrations, availableConcentrations, availableAdvisors }, index) of current.programs" :key="major" :cols="12" :sm="6" :md="4" :xl="3">
          <v-card>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Major</v-list-item-subtitle>
                    <v-list-item-title>{{ getDesc('major', major) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Advisor{{ advisors.length > 1 ? 's' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-for="{ text, value } in advisors" :key="'advr-' + value">{{ text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="concentrations.length > 0 || availableConcentrations.length > 0">
                  <v-list-item-subtitle v-if="concentrations.length === 0">No Concentrations Selected</v-list-item-subtitle>
                  <v-list-item-content v-else>
                    <v-list-item-subtitle>Concentration{{ concentrations.length === 1 ? '' : 's' }}</v-list-item-subtitle>
                    <v-list-item-title v-for="{ text, value } of concentrations" :key="'conc-' + value">{{ text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <confirm-dialog v-if="current.programs.length > 1" title="Confirm Drop" :message="`Are you sure you want to drop your ${getDesc('major', major)} major?`" @yes="changes.push({ action: 'drop', field: 'major', value: major })">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ action , field, prev }) => field === 'major' && (action === 'drop' || prev === major))">
                    <v-icon left>fal fa-minus-circle</v-icon>
                    Drop
                  </v-btn>
                </template>
              </confirm-dialog>
              <v-btn v-else :disabled="!!changes.find(({ action, field }) => action === 'change' && field === 'major')" class="mb-1" @click="openMajorChangeDialog('add', major)">
                <v-icon left>fal fa-plus-circle</v-icon>
                {{ major === '0000' ? 'Declare major' : 'Add' }}
              </v-btn>
              <v-spacer />
              <v-menu v-if="major !== '0000'" v-model="changeMajorMenu[index]" close-on-content-click>
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ action, field, prev }) => action === 'change' && field === 'major' && prev === major)">
                    <v-icon left>fal fa-exchange</v-icon>
                    Change
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openMajorChangeDialog('change', major)">
                    <v-list-item-title>Change Major</v-list-item-title>
                  </v-list-item>
                  <v-list-item :disabled="availableAdvisors.filter(({value}) => !advisors.find(({ value: v }) => v === value)).length === 0" @click="openAdvisorChangeDialog(major)">
                    <v-list-item-content>
                      <v-list-item-title>Request Advisor Change</v-list-item-title>
                      <v-list-item-subtitle v-if="availableAdvisors.filter(({value}) => !advisors.find(({ value: v }) => v === value)).length === 0">No other advisors available</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="availableConcentrations.length > 0">
                    <v-list-item-title>Change Concentrations</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>
          </v-card>
        </v-col> -->
        <major-dialog v-model="majorDialogActive" :action="majorDialogAction" :major-items="majorItems" @save="saveMajorChange" />
        <advisor-dialog v-model="advisorDialogActive" :major="advisorChangeMajor" @save="saveAdvisorChange" />
        <v-col :cols="12" :sm="6" :md="4" :xl="3">
          <v-card>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Minor{{ current.minors.length === 1 ? '' : 's' }}</v-list-item-subtitle>
                    <v-list-item-title v-for="{ value, text } in current.minors" :key="'minor-' + value">{{ text }}</v-list-item-title>
                    <v-list-item-title v-if="current.minors.length === 0">**No declared minors**</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-dialog v-model="addMinorDialog" width="500" v-if="current.minors.length < 3">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ action, field }) => action === 'add' && field === 'minor')">
                    <v-icon left>fal fa-plus-circle</v-icon>
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>Add Minor(s)</v-card-title>
                  <v-card-text>
                    <p>Please choose what minor you would like to add. You can have 3 total minors.</p>
                    <v-autocomplete v-model="minorsToAdd" :items="minorAddOptions" label="Minor(s)" multiple outlined chips small-chips deletable-chips />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click="addMinorDialog = false">Cancel</v-btn>
                    <v-spacer />
                    <v-btn :disabled="minorsToAdd.length === 0" color="success" @click="addMinors()">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer />
              <confirm-dialog v-if="current.minors.length === 1" title="Confirm Drop" :message="`Are you sure you want to drop your ${current.minors[0].text} minor?`" @yes="changes.push({ action: 'drop', field: 'minor', value: current.minors[0].value })">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ action, field }) => action === 'drop' && field === 'minor')">
                    <v-icon left>fal fa-minus-circle</v-icon>
                    Drop
                  </v-btn>
                </template>
              </confirm-dialog>
              <v-menu v-else-if="current.minors.length > 1" v-model="minorDrop">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ action, field}) => action === 'drop' && field === 'minor')">
                    <v-icon left>fal fa-minus-circle</v-icon>
                    Drop
                  </v-btn>
                </template>
                <v-list>
                  <confirm-dialog v-for="{ value, text } in current.minors" :key="value" title="Confirm Drop" :message="`Are you sure you want to drop your ${text} minor?`" @yes="changes.push({ action: 'drop', field: 'minor', value })">
                    <template #activator="{ on }">
                      <v-list-item v-on="on" :disabled="changes.find(({ action, field }) => action === 'drop' && field === 'minor')">
                        <v-list-item-title>Drop {{ text }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </confirm-dialog>
                </v-list>
              </v-menu>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-card v-if="includeP12 || isEDSTMajor" class="mb-2">
        <v-card-text>
          <h4>Education or Teacher Certification</h4>
          <template v-if="includeP12">
            <p>Students who desire to teach in a field from their selected major are encouraged to minor in Education followed by completion of the Master of Arts in Teaching degree at Covenant. Note: if you choose not to minor in Education, you are required to complete three pre-requisite education courses: Introduction to Teaching, Education Psychology, and Education of Exceptional Children.</p>
            <v-checkbox :value="P12Secondary" label="P-12 or Secondary (grades 6-12) Education - the five year secondary certification program including MAT degree" readonly />
          </template>
          <template v-if="isEDSTMajor">
            <p>Students who desire middle grades certification should complete the fifth-year Master of Arts in Teaching degree at Covenant. You must also select two content fields in the box below.</p>
            <v-list-item>
              <v-list-item-subtitle>Content Fields</v-list-item-subtitle>
              <v-list-item-title>{{ contentFieldItems.filter(({ value }) => EDSTContentFields.includes(value)).map(({ text }) => text).join('; ') }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-card-text>
      </v-card>
      <v-alert v-for="({ type, text }, index) of changeAlerts" :key="index" :type="type">
        {{ text }}
        <template #append>
          <v-btn @click="changes.splice(index, 1)">Cancel</v-btn>
        </template>
      </v-alert>
      <v-card v-if="changes.length > 0">
        <v-card-text>
          <v-textarea v-model="comment" label="Add Comment" rows="3" outlined hide-details />
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!comment" color="success" text @click="addComment">Save Comment</v-btn>
        </v-card-actions>
      </v-card>
      <v-toolbar flat style="margin-bottom:40px" class="mt-4">
        <v-btn text to="/student" class="mr-2">Cancel</v-btn>
        <v-btn color="success" :disabled="!isValid" @click="save">Save</v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
  </div>
</template>
<script>
import { ref, computed, reactive, watch, onMounted } from '@vue/composition-api'
import { inArray } from '@/helpers/functions'

export default {
  components: {
    ConfirmDialog: () => import('@/components/system/confirmDialog'),
    MajorDialog: () => import('@/components/student/program-change/major-dialog'),
    AdvisorDialog: () => import('@/components/student/program-change/advisor-dialog')
  },
  setup (props, { root }) {
    const service = root.$feathers.service('student/major-change')
    const settingServ = root.$feathers.service('student/reg-setting')

    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const roles = computed(() => root.$store.state.roles)
    const required = ref([(v) => !!v || 'Required'])
    const dataLoaded = ref(false)
    const term = ref('')
    const termLabel = ref('')

    const current = reactive({
      programs: [],
      minors: [],
      p12: false,
      contentField: []
    })
    const changes = ref([])
    const changeAlerts = computed(async () => changes.value.map(({ action, field, value, prev, advisor, concentrations }) => {
      const actionName = action.substring(0, 1).toUpperCase() + action.substring(1)
      const fieldName = field.substring(0, 1).toUpperCase() + field.substring(1)
      let text = `${actionName} ${fieldName}`
      if (action === 'change') {
        text += ` from ${getDesc(field, prev)} to`
      }
      text += `: ${getDesc(field, value)}`
      if (field === 'major') {
        text += ` with Advisor ${getDesc('advisor', advisor)}`
        if (concentrations && concentrations.length > 0) {
          text += ` and Concentrations: ${concentrations.map(({ value }) => getDesc('concentration', value))}`
        }
      }
      const obj = { type: 'info', text }
      if (action === 'add') obj.type = 'success'
      else if (action === 'drop') obj.type = 'error'
      return obj
    }))

    const submission = ref({})
    const status = computed(() => 'status' in submission.value ? submission.value.status : 'Unsubmitted')
    const original = reactive({})

    const programs = ref([])
    const majorItems = ref([])

    const minor = ref([])
    const minorItems = ref([])
    watch(minor, () => {
      if (minor.value.length > 2) {
        minor.value.splice(2, 1)
      }
    })

    onMounted(async () => {
      if ('Records' in roles.value || 'Employee' in roles.value || 'All Adjuncts' in roles.value || 'Technology Services' in roles.value) {
        root.$router.replace('/student/program-change/admin')
        return
      }
      // Load the major options
      const aggregate = [
        { $match: {
          form: 'program',
          category: 'major'
        } },
        { $unwind: '$options' },
        { $addFields: {
          value: '$options.value',
          text: '$options.text'
        } },
        { $lookup: {
          from: 'Student-RegSetting',
          as: 'options',
          let: { major: '$value' },
          pipeline: [
            { $match: {
              $or: [
                {
                  $expr: { $eq: ['$major', '$$major'] }
                },
                { $and: [
                  { $expr: { $eq: ['$$major', 'IDS'] } },
                  { $expr: { $eq: ['$major', 'IDS-Primary'] } }
                ] }
              ]
            } }
          ]
        } },
        { $sort: { text: 1 } }
      ]
      const { data } = await settingServ.find({ query: { aggregate } })
      majorItems.value = data
      console.log(majorItems.value)
      // Load the minor options
      settingServ.find({ query: { form: 'program', category: 'minor', $sort: { term: -1 }, $limit: 1 } }).then(({ data }) => {
        minorItems.value = data[0].options
      })
      // Get possible terms from the term warehouse; all terms that have not yet ended
      let { data: termData } = await root.$feathers.service('system/term').find({ query: { end: { $gt: new Date() }, $limit: 50 } })
      let terms = []
      for (let i = 0; i < termData.length; i++) {
        terms.push(termData[i].term)
      }
      // Load the PIDM of the current user
      let pidm = user.value.pidm
      // Check to see if the student has a submission for any of the given terms; if so, we will use that to populate the submission and the original data, in the case where they are making further changes
      const { data: changeData } = await service.find({ query: { pidm, term: { $in: terms } } })
      if (changeData.length > 0) {
        submission.value = changeData[0]
        if (status.value === 'Submitted' || status.value === 'Pending' || status.value === 'Approved') {
          dataLoaded.value = true
          return
        }
      }
      // Load the student's academic data from the student/term-detail for any of the active or future terms, sorted with the term code ascending
      // This will load the current term first, if there is a record for it, or for the next term to begin
      let { data: studentData } = await root.$feathers.service('student/term-detail').find({ query: { pidm, term: { $in: terms }, $sort: { term: 1 } } })
      if (studentData.length > 0) {
        let { academics, term: termCode } = studentData[0]
        term.value = termCode
        const { data: termData } = await root.$feathers.service('system/term').find({ query: { term: termCode } })
        if (termData.length > 0) termLabel.value = termData[0].label
        for (let l in academics) {
          if (Array.isArray(academics[l])) original[l] = academics[l].filter((val) => val !== '')
          else original[l] = academics[l]
        }
        console.log(academics)
        setInitialData(academics)
        dataLoaded.value = true
      } else {
        root.$store.dispatch('main/snackbar', { active: true, color: 'error', timeout: 10000, text: 'No enrollment details were found for you in any active term. Please contact the Records office for assistance.' })
        root.$router.replace('/')
      }
    })

    async function setInitialData ({ major, minor, concentration, advisor }) {
      current.programs = []

      let isFirst = true
      for (const maj of major) {
        const prog = {
          major: maj,
          advisors: [],
          concentrations: [],
          availableAdvisors: [],
          availableConcentrations: []
        }
        const rec = majorItems.value.find(({ value }) => value === maj)
        console.log(rec)
        for (const { category, options } of rec.options) {
          if (category === 'advisor') {
            console.log(options)
            // Find any major advisors in the advisor list and match them to what's in the options list
            prog.availableAdvisors = options
            const arr = options.filter(({ value }) => advisor.find(({ code, pidm }) => code.substr(0, 3) === 'MAJ' && pidm === value))
            if (arr.length === 0) {
              const advrPidm = advisor.find(({ code }) => code === (isFirst ? 'MAJR' : 'MAJ2')).pidm
              const text = await getAdvrName(advrPidm)
              prog.advisors = [{ value: advrPidm, text }]
            } else {
              prog.advisors = arr
            }
          } else if (category === 'concentration') {
            if (prog.concentrations.length === 0) {
              prog.concentrations = options.filter(({ value }) => concentration.includes(value))
              prog.availableConcentrations = options
            } else {
              options.filter(({ value }) => concentration.includes(value)).forEach((row) => prog.concentrations.push(row))
            }
          }
        }
        current.programs.push(prog)
        isFirst = false
      }
      current.minors = minorItems.value.filter(({ value }) => minor.includes(value))
    }

    async function save () {
      if (form.value.validate()) {
        console.log('Form is valid')
      }
      const obj = {
        term: term.value,
        pidm: user.value.pidm,
        bannerId: user.value.bannerId,
        name: user.value.name,
        status: 'Submitted',
        program: current.programs,
        minor: current.minors,
        p12: P12Secondary.value,
        contentFields: EDSTContentFields.value,
        changes: changes.value
      }
      const timeline = {
        pidm: user.value.pidm,
        name: user.value.name,
        date: new Date(),
        text: 'Request Submitted',
        icon: 'fal fa-save',
        color: 'info',
        visibleToStudent: true
      }
      console.log(obj)
      let { data } = await service.find({ query: { term: term.value, pidm: user.value.pidm } })
      if (data.length > 0) {
        obj.$push = { timeline }
        await service.patch(data[0]._id, obj)
      } else {
        obj.timeline = [timeline]
        await service.create(obj)
      }
      await root.$feathers.service('system/email').create({
        from: { email: 'report-email@covenant.edu', name: 'Program Change' },
        to: 'jon.moon@covenant.edu',
        subject: 'Program/Advisor Change Submitted',
        html: user.value.preferred + ' ' + user.value.last + ' has submitted a program/advisor change. Please click on the link below to access the Program/Advisor Change system to review this request.<br/><br/><a href="https://portal.covenant.edu/student/program-change">https://portal.covenant.edu/student/program-change</a>'
      })
      root.$store.dispatch('main/snackbar', { active: true, color: 'success', timeout: 6000, text: 'Your program/advisor change form was submitted successfully.' })
      root.$router.push('/student/program-change/status')
    }

    /** Education add-ons */
    const eduMajors = {
      ART: true,
      BIB: true,
      BIO: true,
      CHE: true,
      COS: true,
      ECO: true,
      ENG: true,
      FRE: true,
      GER: true,
      HIS: true,
      MAT: true,
      MUS: true,
      PHY: true,
      POLS: true,
      SPA: true,
      THET: true
    }
    const includeP12 = computed(() => current.programs.reduce((prev, { major }) => prev || major in eduMajors, false))
    const P12Secondary = ref(false)
    watch(P12Secondary, (val) => {
      if (val && !minor.value.reduce((prev, minr) => prev || minr === 'EDU', false)) {
        minor.value.push('EDU')
      }
    }, {
      lazy: true
    })
    watch(minor, () => {
      if (P12Secondary.value && !inArray('EDU', minor.value)) {
        P12Secondary.value = false
      }
    })

    const isEDSTMajor = computed(() => programs.value.reduce((prev, { major }) => prev || major === 'EDST', false))
    const EDSTContentFields = ref([])
    const contentFieldItems = ref([
      { value: 'EDLA', text: 'Language Arts' },
      { value: 'EDMA', text: 'Mathematics' },
      { value: 'EDSC', text: 'Science' },
      { value: 'EDSS', text: 'Social Studies' }
    ])
    watch(EDSTContentFields, () => {
      if (EDSTContentFields.value.length > 2) {
        EDSTContentFields.value.splice(2, 1)
      }
    })

    const isValid = computed(() => {
      // for (const { major } of programs.value) {
      //   if (major == null || major === '') return false
      // }
      // if (isEDSTMajor.value && EDSTContentFields.value.length < 2) return false
      return true
    })

    const form = ref(null)
    const formValid = ref(false)

    async function getAdvrName (pidm) {
      const { data: dirData } = await root.$feathers.service('directory/people').find({ query: { pidm } })
      if (dirData.length > 0) {
        return dirData[0].name.last + ', ' + dirData[0].name.first
      }
      return 'Advisor Not Found'
    }
    function getDesc (category, value) {
      // console.log(category, value)
      if (category === 'major') {
        const temp = majorItems.value.find(({ value: v }) => v === value)
        if (temp) return temp.text
      } else if (category === 'minor') {
        const temp = minorItems.value.find(({ value: v }) => v === value)
        if (temp) return temp.text
      } else if (category === 'advisor') {
        for (const { options } of majorItems) {
          const advr = options.find(({ category }) => category === 'advisor')
          const temp = advr.options.find(({ value: v }) => v === value)
          if (temp) return temp.text
        }
      } else if (category === 'concentrations') {
        for (const { options } of majorItems) {
          const conc = options.find(({ category }) => category === 'concentration')
          const temp = conc.options.find(({ value: v }) => v === value)
          if (temp) return temp.text
        }
      }
      return value
    }

    const majorDialogActive = ref(false)
    const majorDialogAction = ref('')
    const majorDialogMajor = ref('')
    function openMajorChangeDialog (action, major) {
      changeMajorMenu.value = [false, false]
      majorDialogAction.value = action
      majorDialogMajor.value = major
      majorDialogActive.value = true
    }
    async function saveMajorChange (rec) {
      changeMajorMenu.value = [false, false]
      const advisorName = await getAdvrName(rec.advisor)
      changes.value.push({ action: majorDialogAction.value, field: 'major', prev: majorDialogMajor.value, ...rec, advisorName })
    }

    const advisorDialogActive = ref(false)
    const advisorChangeMajor = ref('')
    function openAdvisorChangeDialog (major) {
      changeMajorMenu.value = [false, false]
      advisorChangeMajor.value = major
      advisorDialogActive.value = true
    }
    async function saveAdvisorChange (rec) {
      changeMajorMenu.value = [false, false]
      const advisorName = await getAdvrName(rec.value)
      changes.value.push({ action: 'change', field: 'advisor', ...rec, advisorName })
    }

    const minorAddOptions = computed(() => minorItems.value.filter(({ value }) => !current.minors.find(({ value: v }) => value === v)))
    const addMinorDialog = ref(false)
    const minorsToAdd = ref([])
    async function addMinors () {
      for (const minor of minorsToAdd.value) {
        changes.value.push({ action: 'add', field: 'minor', value: minor })
      }
      addMinorDialog.value = false
    }

    watch(minorsToAdd, () => {
      if (minorsToAdd.value.length > 0) {
        let i = current.minors.length - changes.value.filter(({ action, field }) => action === 'drop' && field === 'minor').length
        console.log(i, minorsToAdd.value.length)
        if (i === 3) minorsToAdd.value = []
        if (minorsToAdd.value.length + i > 3) {
          minorsToAdd.value.splice(3 - i, 3)
        }
      }
    })

    const comment = ref('')
    async function addComment () {}

    const changeMajorMenu = ref([false, false])
    function closeMenu (index) {
      changeMajorMenu.value.splice(index, 1, false)
      return true
    }

    return {
      user,
      roles,
      required,
      dataLoaded,
      term,
      termLabel,
      current,
      changes,
      changeAlerts,
      submission,
      status,
      programs,
      majorItems,
      minor,
      minorItems,
      setInitialData,
      save,
      includeP12,
      P12Secondary,
      isEDSTMajor,
      EDSTContentFields,
      contentFieldItems,
      isValid,
      form,
      formValid,
      getAdvrName,
      getDesc,
      majorDialogActive,
      majorDialogAction,
      majorDialogMajor,
      openMajorChangeDialog,
      saveMajorChange,
      advisorDialogActive,
      advisorChangeMajor,
      openAdvisorChangeDialog,
      saveAdvisorChange,
      minorAddOptions,
      addMinorDialog,
      minorsToAdd,
      addMinors,
      comment,
      addComment,
      changeMajorMenu,
      closeMenu
    }
  }
}

// function findDiffs (original, updated) {
//   const rem = original.filter((val) => !inArray(val, updated))
//   const add = updated.filter((val) => !inArray(val, original))
//   return { add, rem }
// }
</script>
